import { render, staticRenderFns } from "./CommentsTree.vue?vue&type=template&id=2f33d0c9&scoped=true&"
import script from "./CommentsTree.vue?vue&type=script&lang=js&"
export * from "./CommentsTree.vue?vue&type=script&lang=js&"
import style0 from "./CommentsTree.vue?vue&type=style&index=0&id=2f33d0c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f33d0c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f33d0c9')) {
      api.createRecord('2f33d0c9', component.options)
    } else {
      api.reload('2f33d0c9', component.options)
    }
    module.hot.accept("./CommentsTree.vue?vue&type=template&id=2f33d0c9&scoped=true&", function () {
      api.rerender('2f33d0c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/CommentsTree.vue"
export default component.exports